import React from 'react';

import { ICONS } from '../../../icons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

function GenieGoHeader() {
  return <ProjectNameHeader icon={ICONS.Genie} defaultName='GenieGo' selector={(state) => state.genieGo.projectName} />;
}

export default GenieGoHeader;
